export default __webpack_public_path__ + "static/media/ic_mail.ae2a49df.svg";